import { MultiSelect } from "react-multi-select-component";

const MultiselectComponent = ({
  label,
  options,
  selectedOptions,
  handleSetSelect,
  required = false,
  className,
}) => {
  return (
    <div>
      <div className="flex items-center">
        <p className="">{label}</p>{" "}
        <span className="text-red-500 pl-1">{required && ` *`}</span>
      </div>
      <MultiSelect
        className={`${className}`}
        options={options}
        value={selectedOptions || []}
        onChange={(selected) => {
          handleSetSelect(selected);
        }}
        labelledBy="Select"
      />
    </div>
  );
};

export default MultiselectComponent;
